export const bolepidemiologicos2026IAAS = [
  {
    "etiqueta_elemento": "Boletín Enero 2026",
    "url_elemento":"../../../contenido/epidemiologia/2026/IAAS/Boletín IAAS Enero 2026.pdf",
  },
  {
    "etiqueta_elemento": "Boletín Febrero 2026",
    "url_elemento":"../../../contenido/epidemiologia/2026/IAAS/Boletín IAAS Febrero 2026.pdf",
  },
  {
    "etiqueta_elemento": "Boletín Marzo 2026",
    "url_elemento":"../../../contenido/epidemiologia/2026/IAAS/Boletín IAAS Marzo 2026.pdf",
  },
  {
     "etiqueta_elemento": "Boletín Abril 2026",
     "url_elemento":"../../../contenido/epidemiologia/2026/IAAS/Boletín IAAS Abril 2026.pdf",
  },
  {
     "etiqueta_elemento": "Boletín Mayo 2026",
     "url_elemento":"../../../contenido/epidemiologia/2026/IAAS/Boletín IAAS Mayo 2026.pdf",
  },
  {
     "etiqueta_elemento": "Boletín Junio 2026",
     "url_elemento":"../../../contenido/epidemiologia/2026/IAAS/Boletín IAAS Junio 2026.pdf",
  },
  {
     "etiqueta_elemento": "Boletín Julio 2026",
     "url_elemento":"../../../contenido/epidemiologia/2026/IAAS/Boletín IAAS Julio 2026.pdf",
  },
  {
     "etiqueta_elemento": "Boletín Agosto 2026",
     "url_elemento":"../../../contenido/epidemiologia/2026/IAAS/Boletín IAAS Agosto 2026.pdf",
  },
]